import { appendUserContextToUrl } from '../util/EnhanceUrlWithCtx';

export const handleSrpUrl = (
  url: string | undefined | null,
  overrideUrl: string | undefined | null,
  params: { sortByLeasingrate: string | undefined | null } | undefined,
  ctx?: string | undefined,
): string => {
  let urlLinkout = url ?? '';

  if (overrideUrl) {
    urlLinkout = overrideUrl;
  } else {
    const regexSortType = /emh(SortType|sort)=(price|name)-(asc|desc)/;
    const linkout =
      params?.sortByLeasingrate === 'ASCENDING'
        ? urlLinkout.replace(regexSortType, 'emhsortType=monthly-asc')
        : params?.sortByLeasingrate === 'DESCENDING'
          ? urlLinkout.replace(regexSortType, 'emhsortType=monthly-desc')
          : (overrideUrl ?? urlLinkout);
    urlLinkout = appendUserContextToUrl(linkout, ctx) ?? '';
  }
  return urlLinkout;
};
